export default "__VITE_ASSET__D_9MAnN6__"